function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 5.2916669 6.6145836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1326",
    transform: "matrix(1.1803244,0,0,1.1935898,-114.20437,-155.65121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g81778",
    style: {
      stroke: "#343434",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.25,
      strokeLinecap: "square",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect21847",
    width: 4.2333331,
    height: 5.2916665,
    x: 96.883331,
    y: 130.5295
  }), /*#__PURE__*/React.createElement("g", {
    id: "g31589",
    style: {
      stroke: "#343434",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect21875",
    style: {
      fill: "none",
      stroke: "#343434",
      strokeWidth: 0.265,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 97.783833,133.0205 h 2.487247 v 1.86543 h -2.487247 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#343434",
      fillOpacity: 1,
      stroke: "#343434",
      strokeWidth: "0.237813px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 98.564127,133.62793 v 0.73226 l 0.862962,-0.36613 z",
    id: "path24661"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOff);
export default __webpack_public_path__ + "static/media/video_off.9459b5e003d6411cc8c65d2310aa2e33.svg";
export { ForwardRef as ReactComponent };